<template>
<div class="contact-page">
  <div class="contact-block">
      <div class="contact-container">
        <p class="sakontakto-mob bold-italic">{{ $fn.tr('საკონტაქტი') }}</p>
        <div class="send-cont">
          <p class="sakontakto bold-italic">{{ $fn.tr('საკონტაქტი') }}</p>
      <a :href="'tel: + ' + getNumber" class="call-div">
        <span class="f-21 light-italic ttl">{{ $fn.tr('ტელეფონი') }}</span>
        <div class="inner-wrapper">
          <span class="f-55 bold">{{ getNumber }}</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="38.917" height="39.928" viewBox="0 0 38.917 39.928">
  <g id="Group_1499" data-name="Group 1499" transform="translate(13.987 3.176) rotate(-45)">
    <g id="menu" transform="translate(-24.753 3.741)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#101820" stroke="#101820" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>
        </div> 
      </a>
<a :href="'mailto:' + getEmail" class="email-div">
        <span class="f-21 light-italic ttl">{{ $fn.tr('ელ.ფოსტა') }}</span>
        <div class="inner-wrapper">
          <span class="f-55 bold">{{ getEmail }}</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="38.917" height="39.928" viewBox="0 0 38.917 39.928">
  <g id="Group_1499" data-name="Group 1499" transform="translate(13.987 3.176) rotate(-45)">
    <g id="menu" transform="translate(-24.753 3.741)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M15.535,20.31a63.817,63.817,0,0,1,8.107-5.662c.783-.464,1.585-.908,2.411-1.294-1.195-.049-2.414,0-3.622.049-1.282.053-2.55.1-3.76.043C13.446,13.164,8.274,12.2,3.029,12.3c-1.8.03-4.764-2.672-1.708-2.729,5.945-.11,11.775,1.069,17.7,1.2.983.018,1.987,0,3-.028a32.561,32.561,0,0,1,6.7.319c-2.928-3.078-6.282-5.747-8.8-9.2-.758-1.035-.156-2.737.879-1.314,3.037,4.168,7.3,7.2,10.557,11.178a1.71,1.71,0,0,1,.271.464,1.362,1.362,0,0,1,.429,1.041c0,.046,0,.089,0,.129-.026.784-1.146.945-2.265.685a15.461,15.461,0,0,0-5.849,2.683,71.757,71.757,0,0,0-6.679,4.765,1.536,1.536,0,0,1-.98.326C15.372,21.817,14.539,21.131,15.535,20.31Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.237)" fill="#101820" stroke="#101820" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>
        </div>
        
      </a>
        </div>

<el-form :model="form" :rules="rules" ref="form" class="contact-form">
  <div class="formTxt">
   <span class="f-55 bold-italic contact-us">{{ $fn.tr('მოგვწერე') }}</span>
  </div>

      <el-form-item  class="input-wrapper" prop="nameIn" ref="nameIn">
        <p class="placeholder f-34 bold-italic" ref="placeholder">{{$fn.tr('Name')}}</p>
           <el-input type="text" v-model="form.nameIn" id="phone-input-1" @focus="movePh" @blur="moveOutPh"></el-input>
      </el-form-item >

        <el-form-item class="input-wrapper" prop="email" ref="email">
           <p class="placeholder f-34 bold-italic" ref="placeholder2">{{$fn.tr('E-Mail')}}</p>
           <el-input type="email" v-model="form.email" id="email-input-1" @focus="movePh2" @blur="moveOutPh2"></el-input>
      </el-form-item>

       <el-form-item  class="input-wrapper" prop="textarea" ref="textarea"  @mouseenter="scrollStatus();" @mouseleave="scrollStatus();">
           <p class="placeholder f-34 bold-italic" ref="placeholder3">{{$fn.tr('Text')}}</p>
         <el-input
            type="textarea"
            :rows="10"
            
            v-model="form.textarea"
            @focus="movePh3" @blur="moveOutPh3"
             id="contact-text"
            >
            </el-input>
      </el-form-item >

  <button class="contact-btn" @click.prevent="submitForm('form')">
    <div class="inner-wrapper">
       <svg xmlns="http://www.w3.org/2000/svg" width="31.675" height="22.988" viewBox="0 0 31.675 22.988">
  <g id="Group_1464" data-name="Group 1464" transform="translate(25.293 -3.205)">
    <g id="menu" transform="translate(-24.754 3.74)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M14.188,18.549a58.283,58.283,0,0,1,7.4-5.171c.715-.424,1.448-.829,2.2-1.182-1.091-.045-2.205,0-3.308.045-1.171.049-2.329.094-3.434.039-4.772-.258-9.5-1.134-14.285-1.043-1.647.027-4.351-2.44-1.56-2.492,5.429-.1,10.753.977,16.168,1.092.9.017,1.815,0,2.742-.025a29.737,29.737,0,0,1,6.123.291C23.565,7.291,20.5,4.854,18.2,1.7c-.692-.945-.142-2.5.8-1.2,2.773,3.807,6.667,6.576,9.641,10.209a1.562,1.562,0,0,1,.248.424,1.243,1.243,0,0,1,.392.951c0,.042,0,.081,0,.118-.024.716-1.047.863-2.069.626a14.12,14.12,0,0,0-5.341,2.45,65.534,65.534,0,0,0-6.1,4.352,1.4,1.4,0,0,1-.9.3C14.039,19.925,13.278,19.3,14.188,18.549Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.043)" fill="#fff" stroke="#fff" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

<span class="f-30">{{ $fn.tr('გაგზავნა') }}</span>
    </div>
    <transition name="fade">
     <div class="err" v-if="Complate">{{ $fn.tr('ოპერაცია წარმატებით დასრულდა!') }}</div>
    </transition>
  </button>
</el-form>
   
     
      </div>
  </div>
</div>
</template>

<script>
import ValidateMixin from "@/mixins/validate";
export default {
  mixins: [ValidateMixin],
data() {
   var checkEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$fn.tr('გთხოვთ შეიყვანოთ ელ.ფოსტა')));
        } else if (!value.includes('@')){
      callback(new Error(this.$fn.tr('გთხოვთ შეიყვანოთ ელ.ფოსტა')));
        }
         else {
         console.log("correct")
          callback();
        }
      };

      var checkName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$fn.tr('გთხოვთ შეიყვანოთ სახელი')));
        } 
         else {
         console.log("correct")
          callback();
        }
      };

       var checkText = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$fn.tr('გთხოვთ შეიყვანოთ ტექსტი')));
        } 
         else {
         console.log("correct")
          callback();
        }
      };
    return {
      form:{
      nameIn: '',
      email: '',
      textarea: '',
      },
      Complate: false,

      rules: {
          email: [
              { required: true, validator: checkEmail, trigger: 'blur' },
            
          ],
           nameIn: [
              { required: true, validator: checkName, trigger: 'blur' },
            
          ],
             textarea: [
              { required: true, validator: checkText, trigger: 'blur' },
            
          ],
          // checkPass: [
          //   { validator: validatePass2, trigger: 'blur' }
          // ],
        
        }
      
    }
},
computed: {
  getNumber() {
    return _.get(this.$store.state.main, 'indx.siteSettings.mobile_phone')
  },
  getEmail() {
    return _.get(this.$store.state.main, 'indx.siteSettings.email')
  }
},
  methods: {
    movePh(e){
      this.$refs.placeholder.style.transform = "translateY(-30px)";
      // this.$refs.placeholder.style.fontSize = "14px";
      
    },
     moveOutPh(){
      
      if(document.querySelector("#phone-input-1").value === ''){
        this.$refs.placeholder.style.transform = "translateY(0)";
        // this.$refs.placeholder.style.fontSize = "34px";
      }
      
    },

      movePh2(e){
      this.$refs.placeholder2.style.transform = "translateY(-30px)";
      // this.$refs.placeholder2.style.fontSize = "14px";
      
    },
     moveOutPh2(){
        if(document.querySelector("#email-input-1").value === ''){
      this.$refs.placeholder2.style.transform = "translateY(0)";
      // this.$refs.placeholder2.style.fontSize = "34px";
        }
    },

      movePh3(e){
      this.$refs.placeholder3.style.transform = "translateY(-30px)";
      // this.$refs.placeholder3.style.fontSize = "14px";
      
    },
     moveOutPh3(){
       if(document.querySelector("#contact-text").value === ''){
      this.$refs.placeholder3.style.transform = "translateY(0)";
      // this.$refs.placeholder3.style.fontSize = "34px";
       }
      
    },
    reset(){
      // this.$refs.nameIn.resetFields();
      // this.$refs.email.resetFields();
      this.$refs.form.resetFields();
        
        console.log('reset')
    },
    scrollStatus(){
      this.$store.state.main.scrollActive = !this.$store.state.main.scrollActive;
      //console.log("mouseover")
    },
    async sendData() {
      let data = {};
      data.name = this.form.nameIn
      data.email = this.form.email
      data.message = this.form.textarea

      let tmp =  await this.$fn.postData('main/saveSubmitedForm',data);
      console.log(tmp.data)
      if (tmp.data[0] === "success") {
           this.reset();
        this.Complate = true
        setTimeout(() => {
          this.Complate = false
        }, 3000);
      } else {
        this.Complate = false
      }
    },
     submitForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            
           console.log('submitted')
           this.sendData();
        
          } 
        });
  },
  }
}
</script>
<style lang="scss" scoped>
.placeholder{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  transition: .5s;
  pointer-events: none;
}
@media (max-width: 1023px) {
  .placeholder {
    font-size: 21px;
  }
}
</style>
<style>
.contact-block .err {
    font-size: 18px;
    color: green;
    position: absolute;
    top: 75px;
    left: 0;
    text-align: left;
    width: 400px;
}
.contact-page .contact-block textarea {
  font-size: 21px;
 
}
@media (min-width: 1024px){
  .contact-page .contact-block textarea {
  padding-top: 10px;
 
}
}
.contact-block .el-form-item {
  margin-bottom: 60px;
}
.contact-block .formTxt {
  margin-bottom: 93px;
  width: 100%;
}
.contact-page .contact-block input {
  margin-bottom: 35px;
}
.contact-page .contact-block #phone-input-1, .contact-page .contact-block #email-input-1 {
  font-size: 21px;
  padding-bottom: 0px;
}
.contact-page form {
  width: 55%;
}
.contact-container {
  max-width: 1920px;
  padding: 0 500px;
  padding: 0 400px;
  margin: auto;
  display: block;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  width: 100%;
}
.contact-page .contact-block {
  display: -webkit-box;
  display: -ms-flexbox;
      -ms-flex-align: center;
          align-items: center;
  width: 100%;
  padding-top: 244px;
  padding-top: 80px;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
}
.contact-page .contact-block .input-wrapper span {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 100%;
  width: 540px;
  flex: none;
  padding-right: 60px;
}
.contact-page .contact-block .send-cont {
  width: 45%;
}
.contact-page .contact-block .sakontakto {
  font-size: 21px;
  color: #101820;  
  margin-bottom: 34px;
}
.contact-page .contact-block .sakontakto-mob {
  font-size: 21px;
  color: #101820;  
  display: none;
  margin-bottom: 13px;
}

.contact-page .contact-block .call-div span, .contact-page .contact-block .email-div span {
  font-size: 34px;
}
.contact-page .contact-block .call-div .ttl, .contact-page .contact-block .email-div .ttl {
  font-size: 21px;
  margin-bottom: 30px;
}
.contact-page .contact-block .contact-form svg {
  margin-bottom: 84px;
}

.contact-page .contact-block .contact-form .contact-us {
  font-size: 21px;
  width: 100%;
  margin-bottom: 34px;
}
@media (max-width: 1679px) {
  .contact-container {
    padding: 0 162px;
  }
  .contact-page .placeholder {
    top: -8px;
  }
}
@media (max-width: 1439px) {
  .contact-page .contact-block .input-wrapper {
    margin-bottom: 72px;
  }
  .contact-page .contact-block .call-div .ttl, .contact-page .contact-block .email-div .ttl {
    margin-bottom: 0px;
  }
  .contact-page .contact-block .call-div {
    margin-bottom: 61px;
  }
  .contact-page .placeholder {
    top: -22px;
  }
}
@media (max-width: 1365px) {
  .contact-container {
    padding: 0 47px;
  }
}
@media (max-width: 1023px) {
  .contact-container {
    padding: 0 42px;
    flex-direction: column;
  }
  .contact-page .contact-block .sakontakto-mob {
    display: flex;
  }
  .contact-page .contact-block .sakontakto {
    display: none;
  }
  .contact-page .contact-block .send-cont, .contact-page .contact-block .contact-form {
    width: 100% !important;
    padding-left: 0px !important;
    padding-right: 0px !important; 
  }
  .contact-page .contact-block .send-cont {
    display: flex;
    flex-direction: row;
  }
  .placeholder {
      font-size: 21px;
    }

  .contact-page .contact-block .call-div, .contact-page .contact-block .email-div {
    width: 50%;
  }
  .contact-page .contact-block .call-div span, .contact-page .contact-block .email-div span {
    font-size: 21px !important;
  }
  .contact-page .contact-block .call-div .ttl, .contact-page .contact-block .email-div .ttl {
    font-size: 16px !important;
    margin-bottom: 0px !important;
  }
  .contact-page .contact-block .email-div {
    margin-bottom: 0px !important;
    height: 60px;
    margin-left: 7.5px !important;
  }
  .contact-page .contact-block .call-div {
    padding-bottom: 0px !important;
    margin-right: 7.5px !important;
  }
}
@media (max-width: 767px) {
  .contact-container {
    padding: 0 17px;
  }
}

</style>

